import React, { FC, ReactNode, useEffect, useState } from 'react';
import { TeamListContext } from './context';
import { KitchenDepartmentType, TeamType } from 'models/team-list.model';
import { apiService } from 'utils/api';

const TeamListProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [addTeamFormData, setAddTeamFormData] = useState<TeamType[]>([]);
  const [editMemberFormData, setEditMemberFormData] = useState({} as TeamType & { id?: string });
  const [departments, setDepartments] = useState<KitchenDepartmentType[]>([]);

  const fetchDepartments = async () => {
    try {
      const res = await apiService.get('kitchen/department', {
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      setDepartments(
        res.data.data.map((d: { name: string; id: string }) => ({
          text: d.name,
          value: d.id
        }))
      );
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  return (
    <TeamListContext.Provider
      value={{
        addTeamFormData,
        setAddTeamFormData,
        editMemberFormData,
        setEditMemberFormData,
        departments
      }}>
      {children}
    </TeamListContext.Provider>
  );
};

export default TeamListProvider;
